import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import { detect } from 'detect-browser';

import numeral from 'numeral';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'numeral/locales/sk';
import jwt from 'jsonwebtoken';

import {
  LS_LANGUAGE,
  LS_CURRENCY,
  LS_REFRESH_TOKEN,
  LS_ACCESS_TOKEN,
  LS_REDIRECT_URL,
} from './constants';

const browser = detect();
const { version } = browser;
const dotPosition = version.indexOf('.');
const numberedVersion = parseInt(version.slice(0, dotPosition), 10);

// Set default language if not set

const initReactApp = (loginStatus) => {
  /*  numeral.register('locale', 'sk-SK', {
    delimiters: {
      thousands: ' ',
      decimal: ',',
    },
  }); */

  numeral.locale('sk');

  if (localStorage.getItem(LS_LANGUAGE) === null) {
    localStorage.setItem(LS_LANGUAGE, process.env.REACT_APP_DEFAULT_LANGUAGE);
  }
  if (localStorage.getItem(LS_CURRENCY) === null) {
    localStorage.setItem(LS_CURRENCY, process.env.REACT_APP_DEFAULT_CURRENCY);
  }
  if (browser && browser.name === 'ie' && numberedVersion < 9) {
    const appElem = document.getElementById('root');
    appElem.innerHTML =
      '<p>We are sorry but your browser is outdated. Please ' +
      '<a style="color: blue; text-decoration: underline" href="https://browsehappy.com" target="_self">' +
      'update your browser</a> to current version.</p>';
  } else {
    ReactDOM.render(<App loginStatus={loginStatus} />, document.getElementById('root'));
  }
};

/* const redirectToLogin = () => {
  window.location.href = `${process.env.REACT_APP_AUTH_URI}/signin`;
}; */

const urlParams = new URLSearchParams(window.location.search);
const redirectUrl = urlParams.get('redirect-url');
if (redirectUrl !== null && redirectUrl !== undefined) {
  localStorage.setItem(LS_REDIRECT_URL, redirectUrl);
}

const tokens = window.location.hash.replace('#', '').split('/');
if (tokens.length > 1) {
  localStorage.setItem(LS_ACCESS_TOKEN, tokens[0]);
  localStorage.setItem(LS_REFRESH_TOKEN, tokens[1]);
  window.history.replaceState(null, null, `${redirectUrl || ' '}`);

  /* LOGGED IN */
  initReactApp(true);
} else if (
  localStorage.getItem(LS_ACCESS_TOKEN) !== null &&
  localStorage.getItem(LS_REFRESH_TOKEN) !== null &&
  localStorage.getItem(LS_ACCESS_TOKEN) !== undefined &&
  localStorage.getItem(LS_REFRESH_TOKEN) !== undefined
) {
  let accessToken = localStorage.getItem(LS_ACCESS_TOKEN);
  let refreshToken = localStorage.getItem(LS_REFRESH_TOKEN);
  const currentTime = Date.now() / 1000;
  const decoded = jwt.decode(accessToken);

  if (accessToken && refreshToken) {
    if (decoded.exp < currentTime) {
      /* OLD TOKEN */
      localStorage.removeItem(LS_ACCESS_TOKEN);
      localStorage.removeItem(LS_REFRESH_TOKEN);
      window.location.reload();
    } else {
      window.history.replaceState(null, null, `${redirectUrl || ' '}`);
      /* LOGGED IN FROM TOKEN*/
      initReactApp(true);
    }
  }
} else {
  /* NOT LOGGED IN */
  initReactApp(false);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
